import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Send, Users } from "lucide-react";
import { toast } from "sonner";

export default function SchoolInvitationsPage() {
  const [candidates, setCandidates] = useState([]);
  const [sent, setSent] = useState([]);
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [form, setForm] = useState({ scholarship_rate: 50, scholarship_type: "achievement", message: "" });

  const load = () => {
    api.get(`${V1}/invitations/eligible-students?limit=100`).then((r) => setCandidates(r.data || []));
    api.get(`${V1}/invitations/mine`).then((r) => setSent(r.data || []));
  };
  useEffect(() => { load(); }, []);

  const invite = async () => {
    try {
      await api.post(`${V1}/invitations`, {
        child_id: target.child_id,
        parent_id: target.parent_id,
        scholarship_rate: parseInt(form.scholarship_rate),
        scholarship_type: form.scholarship_type,
        message: form.message,
      });
      toast.success("Davet gönderildi");
      setOpen(false);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gönderilemedi"); }
  };

  return (
    <div className="space-y-6" data-testid="school-invitations-page">
      <div>
        <div className="overline text-accent">Öğrenci Davetleri</div>
        <h1 className="font-display text-3xl font-bold">Uygun Öğrenciler</h1>
        <p className="text-muted-foreground mt-1">İzin verilen filtrelerle deneme sınavı başarısına göre uygun öğrenci profilleri.</p>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Öğrenci</th>
              <th className="text-left p-3">Sınıf</th>
              <th className="text-left p-3">İl</th>
              <th className="text-left p-3">Ortalama</th>
              <th className="text-left p-3">Sınav Sayısı</th>
              <th className="text-left p-3"></th>
            </tr>
          </thead>
          <tbody>
            {candidates.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground">Uygun aday öğrenci yok.</td></tr>}
            {candidates.map((c) => (
              <tr key={c.child_id} className="border-t border-border" data-testid={`cand-${c.child_id}`}>
                <td className="p-3">{c.first_name} ({c.parent_name})</td>
                <td className="p-3">{c.grade_level}</td>
                <td className="p-3">{c.province || "-"}</td>
                <td className="p-3 font-mono">{c.overall_average !== null ? `%${c.overall_average}` : "-"}</td>
                <td className="p-3">{c.exams_completed}</td>
                <td className="p-3 text-right">
                  <Button size="sm" variant="outline" onClick={() => { setTarget(c); setOpen(true); }} data-testid={`invite-${c.child_id}`}>
                    <Send className="h-3 w-3" /> Davet
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="rounded-xl border border-border bg-card p-6">
        <div className="font-display font-bold text-lg mb-3">Gönderilen Davetler</div>
        <div className="space-y-2 text-sm">
          {sent.length === 0 && <div className="text-muted-foreground">Henüz davet göndermediniz.</div>}
          {sent.map((i) => (
            <div key={i.id} className="flex justify-between border-b border-border py-2">
              <span>{i.child?.name} {i.child?.surname}</span>
              <span className="text-muted-foreground">%{i.scholarship_rate} {i.scholarship_type}</span>
              <span className="px-2 py-0.5 bg-muted rounded text-xs uppercase">{i.status}</span>
            </div>
          ))}
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Davet Gönder</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="text-sm text-muted-foreground">Alıcı: {target?.first_name} — {target?.grade_level}. sınıf</div>
            <div>
              <Label>Burs Oranı (%)</Label>
              <Input type="number" value={form.scholarship_rate} onChange={(e) => setForm({ ...form, scholarship_rate: e.target.value })} />
            </div>
            <div>
              <Label>Burs Türü</Label>
              <Input value={form.scholarship_type} onChange={(e) => setForm({ ...form, scholarship_type: e.target.value })} />
            </div>
            <div>
              <Label>Mesaj</Label>
              <Textarea rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Vazgeç</Button><Button onClick={invite} data-testid="send-invite-btn"><Send className="h-4 w-4" /> Gönder</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
